import moment from "moment";

export const validatorDate = (value, setValue) => {
  if (value.length === 0) return "Campo requerido";

  let date = value;

  let dateNow = moment().format("YYYY-MM-DD");
  let validateYearClient =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) >= 18 &&
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) <= 79;

  let validatedateYear = parseInt(date.split("-")[0]) >= 1900;

  let validateAgePresent =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) === 79;

  let validateAgePresentDps =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) >= 70;

  let validateDateOfAgeLimit =
    parseInt(dateNow.split("-")[1]) - parseInt(date.split("-")[1]) === 0 &&
    parseInt(dateNow.split("-")[2]) >= parseInt(date.split("-")[2]);

  if (!validatedateYear && value.length > 0)
    return "Ingrese un DNI válido en el rango de 18 a 79 años";
  if (!validateYearClient && value.length > 0)
    return "Ingrese un DNI válido  en el rango de 18 a 79 años";
  if (validateAgePresent && validateDateOfAgeLimit)
    return "Ingrese un fecha menor a los 80 años";
  if (validateAgePresentDps) setValue("dps", "true");
  //return "Ingrese un fecha menor a los 69 años";
};

export const validatorFieldFirstName = value => {
  if (value == "") return "Campo requerido 22";
};

export const validatorField = value => {
  if (value == "") return "Campo requerido";
};

export const validatorFieldPrima = (values, getValues) => {
  let money_rg = getValues().money_rg;

  if (values == "") return "Campo Requerido";

  if (money_rg == "PEN" && parseFloat(values.split(",").join("")) < 50000)
    return "Prima Comercial: Prima debe ser mayor a S/100,000";

  if (money_rg == "USD" && parseFloat(values.split(",").join("")) < 15000)
    return "Prima Comercial: Prima debe ser mayor a $/30,000";
};

export const validateDni = (value, getValues) => {
  let typeDoc = getValues().typeDoc;

  let validateLengthNumberDni = value.toString().length < 8;
  let validateLengthNumberCE = value.toString().length < 9;

  if (validateLengthNumberDni && typeDoc == "2")
    return "Ingrese un documento correcto";
  if (validateLengthNumberCE && typeDoc == "1")
    return "Ingrese un documento correcto";

  if (value.length == "") return "Campo requerido";
};

export const validateDefermentMonths = (value) => {
  const defermentMonths = [0, 12, 24, 36, 48, 60];
  if (!defermentMonths.includes(parseInt(value)))
    return "Seleccione un diferimiento válido";

  // let temporalYears = getValues().temporalYears;
  // if (temporalYears * 12 <= value)
  //   return "El diferimiento no puede ser mayor a la temporalidad";
};

export const validateDefermentMonthsInputFree = (value, temporalYears, clearError, formControl) => {

  const temporalYearInMonths = temporalYears * 12;
  if (value >= temporalYearInMonths)
    return "Los meses no deben ser mayor o igual a años temporal";
  else
    clearError(formControl)
  // let temporalYears = getValues().temporalYears;
  // if (temporalYears * 12 <= value)
  //   return "El diferimiento no puede ser mayor a la temporalidad";
};

export const validatePremiumRefund = value => {
  if (!Number.isInteger(parseInt(value))) return "Debe ingresar un número";
  else if (!value >= 0 && value <= 100)
    return "La devolución de prima debe estar entre 0% y 100%";
};

export const validateTirObjetive = (value, clearError, formControl, maxValue) => {
  if (!Number.isInteger(parseInt(value)))
    return "Debe ingresar un número";
  else if (!(parseFloat(value) <= maxValue))
    return "La TIR no debe ser mayor a " + maxValue;
  else
    clearError(formControl)
}

export const validateTemporalYears = (value) => {
  const temporalYears = [1, 2, 3, 5, 7, 10, 15, 20, 25];
  if (!temporalYears.includes(parseInt(value)))
    return "Seleccione un año temporal válido";
};

export const validateTemporalYearsAsAdmin = (value, clearError, formControl) => {
  if (!Number.isInteger(parseInt(value)))
    return "Debe ingresar un número";
  else if (!(parseInt(value) >= 2 && parseInt(value) <= 99))
    return "El año temporal debe ser entre 2 años a 99 años.";
  else
    clearError(formControl)
};

export const validateDoublePaymentMonths = (value) => {
  const doublePaymentMonths = [0, 12, 24, 36, 48, 60];
  if (!doublePaymentMonths.includes(parseInt(value)))
    return "Seleccione un mes de doble pago válido";
};

export const validateDoublePaymentMonthsAdmin = (value, clearError, formControl, temporalYears) => {
  const temporalYearInMonths = temporalYears * 12
  if (value > temporalYearInMonths)
    return `Los meses no deben ser mayor a años temporales`;
  else
    clearError(formControl)
};

export const validateCesionComision = (value, clearError, formControl) => {
  if ( value > 100 )
    return "La cesión de comisión debe estar entre 0% y 100%";
  else
    clearError(formControl)
};

export const validatePensionPeriod = (value) => {
  const pensionPeriod = [1, 2, 3, 4, 6, 12];
  if (!pensionPeriod.includes(parseInt(value)))
    return "Seleccione una periodicidad de pago válida";
};

export const validateGuaranteedPeriod = (value) => {
  if (!Number.isInteger(parseInt(value)))
    return "Debe ingresar un número";
  else if (!(parseInt(value) >= 0 && parseInt(value) <= 100))
    return "La cesión de comisión debe estar entre 0 y 100";
};